module.exports = __webpack_public_path__ + "images/117_160.jpg";